<template>
	<div class="attention-empty">
		<div class="empty-view">
			<img :src="require('@/assets/images/comp/attention-empty.png')" alt="" />
			<div class="button-view">
				<!-- <el-button type="text" @click="addTipChange">如何添加外协厂</el-button> -->
				<br />
				<el-button type="text" @click="compRecommOpen"><span class="att-rec-btn">我要推荐优秀外协厂上平台</span></el-button>
			</div>
		</div>

		<div class="add-tip" :class="addTip ? 'active' : ''">
			<i class="el-icon-close" @click="addTipChange"></i>
			<div class="add-view">
				<div class="header">添加我的供应商步骤</div>
				<div class="plan-box" v-for="({ title, steps }, index) in planList" :key="index">
					<div class="plan-title">{{ title }}</div>
					<div class="step-box" v-for="({ name, list }, j) in steps" :key="j">
						<div class="left-num">{{ j + 1 }}</div>
						<div class="right-content">
							<div class="step-title">{{ name }}</div>
							<div class="step-item" v-for="(item, k) in list" :key="k">
								<img :src="require(`@/assets/images/comp/supplier/${item}.png`)" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			addTip: false,
			recommdTip: false,
			planList: [
				{
					title: "方案1：拖拽添加",
					steps: [
						{
							name: "点击金牌/银牌/铜牌供应商",
							list: ["1-1"],
						},
						{
							name: "鼠标移动到想要添加的供应商右下角的“移动”图标 上，将其拖拽到供应商列表中。",
							list: ["1-2"],
						},
					],
				},
				{
					title: "方案2：搜索命令添加",
					steps: [
						{
							name: "点击“大搜索”，在搜索框中输入关键词",
							list: ["2-1"],
						},
						{
							name: "点击想要添加的供应商名称",
							list: ["2-2"],
						},
						{
							name: "点击“添加到供应商”按钮",
							list: ["2-3"],
						},
						{
							name: "在弹窗中选择放入的目录",
							list: ["2-4"],
						},
					],
				},
			],
		};
	},
	methods: {
		addTipChange() {
			this.addTip = !this.addTip;
		},
		compRecommOpen() {
			this.addTip = false;
			this.$emit('compRecommOpen');
		}
	},
};
</script>

<style lang="less" scoped>
.attention-empty {
	width: 100%;
	display: flex;
	flex-direction: row;
	img {
		width: 76%;
		max-width: 1000px;
		display: block;
		margin: 0 auto;
	}
}
.empty-view {
	flex: 1;
	padding-top: 30px;
	transition: all 0.3s;
}
.button-view {
	text-align: center;
	/deep/ .el-button {
		padding: 10px 0;
		font-size: 15px;
		text-decoration: underline;
	}
}
.add-tip {
	width: 0;
	transition: all 0.3s;
	position: relative;
	overflow: hidden;
	/deep/ .el-icon-close {
		display: block;
		position: absolute;
		right: 0;
		top: 0;
		width: 36px;
		height: 36px;
		text-align: center;
		line-height: 36px;
		font-size: 18px;
		cursor: pointer;
	}

	.header {
		font-size: 16px;
		color: #2f3748;
		font-weight: bold;
	}
	.plan-box {
		margin-top: 13px;
		& + .plan-box {
			margin-top: 25px;
		}
		.plan-title {
			font-size: 14px;
			color: #0989c5;
		}
		.step-box {
			margin-top: 20px;
			display: flex;
			align-items: flex-start;
			line-height: 20px;

			.left-num {
				border-radius: 50%;
				text-align: center;
				width: 20px;
				height: 20px;
				font-size: 12px;
				flex-shrink: 0;
				background-color: #334161;
				font-weight: 700;
				color: #fff;
			}
			.right-content {
				margin-left: 8px;
				flex: 1;
				.step-title {
					font-size: 14px;
					color: #2f3748;
				}
				.step-item {
					margin-top: 10px;
					img {
						width: 100%;
					}
				}
			}
		}
	}
}
.add-view{
	width: 410px;
	height: calc(100vh - 64px);
	overflow-y: auto;
	overflow-x: hidden;
	border-left: 1px solid transparent;
	padding: 14px;
	border-left: 1px solid #d6d6d6;
}
.add-tip.active {
	width: 410px;
}
</style>
